export default __webpack_public_path__ + "static/media/gold_roughness.7ae21d0e.jpg";